import { nanoid } from 'nanoid'
import { proxy } from 'valtio'
import { devtools } from 'valtio/utils'

import {
  getAppChatRecord,
  getAssistantDetail,
  getAssistantList,
  getAssistantType,
  getDefaultImages,
  getKnList,
  getRecordList,
  getSessionsHistory,
  questionGuide,
  getFeatureList,
  getOfficialRecommendList,
} from '@/api/assistant'
import { SessionStatuTypes } from '@/constants'
export const assistantState = proxy<any>({
  curChatId: '',
  curSearchText: '',
  // 助手类型
  assistantTypes: [],
  // 推荐助手列表
  recommandList: [],
  // 官方推荐列表
  officialRecommendList: [],
  // 默认头像列表
  defaultImgs: [],
  defaultImg: '',
  // 知识库列表
  knList: [],
  // 助手会话列表
  historyRecords: [],
  // 单个会话历史记录
  sessionMessages: [],
  // 单个会话参数
  sessionPartMessages: [],
  // 会话记录：从history里查处的当前智能体会话记录，结构复杂，单独处理
  historyRecord: [],
  // 输入框内容
  inputText: '',
  // 会话状态
  sessionStatu: SessionStatuTypes.ready,
  // 热门助手
  hotBotData: {},
  // 获取精选推荐列表
  featureList: [],
  // 首页推荐列表
  featuredApps: [],
  // 自动置顶
  autoBottom: false,
  /**
   * 接口返回的值，以及需要的
   */
  curSelectAssistant: {
    name: '', // 助手名称
    description: '', // 描述
    image: '', // 头像
    welcome_text: '', // 开场白
    question_recommend: ['这里是预置问题'], // 预置问题
    temperature: 0.8,
    knowledge_id: '',
    tools: [],
    question_guide: false,
    prompt: [],
    debug: true,
  },
  // 表单初始值
  initForm: {
    image: '',
    name: '',
    welcome_text: '',
    description: '',
    ability: {
      角色设定: '',
      思考路径: '',
      个性需求: '',
    },
    question_recommend: [{ description: '' }], // 确保初始时有一个输入框
    knowledge_id: [],
    tools: [],
    temperature: 0.9,
  },
  submittable: false,
  curAppId: '',
  isLoadingPage: false,
  isLoadingHistory: false,
  questionGuides: [],
  isLoadingQuestion: false,
  isLoadingChatRecord: false,
  defaultKnConfig: {
    backupChat: true,
    chatMode: 2,
    tipTextVal: 1,
    tipsText: null,
    rankTextThreshold: 0.45,
    removeCornerMark: false,
    isMulti: 0,
  },
})

if (import.meta.env.DEV) {
  devtools(assistantState, { name: 'assistantState', enabled: true })
}

export const assistantAction = {
  getKn: async (payload: any) => {
    try {
      const { data } = await getKnList(payload)
      assistantState.knList = data?.data || []
    } catch (error) {
      return await Promise.reject(error)
    }
  },
  getType: async () => {
    // 官方推荐-获取智能体类型
    try {
      const { data } = await getAssistantType()
      assistantState.assistantTypes = data
    } catch (error) {
      console.log('getType error =>', error)
    }
  },
  getRecommand: async () => {
    // 官方推荐- 智能体推荐列表
    try {
      const { data } = await getAssistantList({
        type: 'recommend',
        page: 1,
        pageSize: 100,
      })
      assistantState.recommandList = data.list
    } catch (error) {
      console.log('getRecommand error =>', error)
    }
  },
  // 获取智能体助手头像
  getDefaultImgs: async () => {
    try {
      const { data } = await getDefaultImages()
      assistantState.defaultImgs = data?.images || []
      assistantState.defaultImg = data?.default || ''
    } catch (error) {
      console.log('getDefaultImgs error =>', error)
    }
  },
  getFeatureList: async () => {
    try {
      const { data } = await getFeatureList()
      assistantState.featuredApps = [
        {
          id: 'igle80qB77HW6Pjk',
          app_code: 'igle80qB77HW6Pjk',
          url: '',
          name: '',
          type: 0,
          description: '',
          image: '',
          knowledge_id: '',
          app_id: '',
          is_hot: false,
          prompt: '',
          is_like: false,
          is_creator: false,
          agent_type: 'kn',
        },
      ].concat(data.list)
      assistantState.featureList = data.list
    } catch (error) {
      console.log('getFeatureList =====>error', error)
    }
  },
  // 获取智能体对话详情
  getAssistantDetail: async (app_id: any) => {
    assistantState.isLoadingPage = true
    try {
      const { data } = await getAssistantDetail({ appId: app_id })
      const { chat_module, ...baseConfig } = data
      assistantState.curSelectAssistant = baseConfig
      if (Object.keys(chat_module?.knowledge)?.length) {
        assistantState.defaultKnConfig = {
          ...chat_module?.knowledge,
          tipTextVal: !chat_module?.knowledge?.tipsText ? 1 : 2,
        }
      }
    } catch (error) {
      console.log('getAssistantDetail error =>', error)
    } finally {
      assistantState.isLoadingPage = false
    }
  },
  // 获取对话历史列表
  getHistoryRecord: async () => {
    assistantState.isLoadingHistory = true
    try {
      const { data } = await getRecordList()
      assistantState.historyRecords = data || []
    } catch (error) {
      console.log('getHistoryRecord error =>', error)
    } finally {
      assistantState.isLoadingHistory = false
    }
  },
  getOfficialRecommendList: async () => {
    try {
      const { data } = await getOfficialRecommendList()
      assistantState.officialRecommendList = data.list
    } catch (error) {
      console.log('getOfficialRecommendList error =>', error)
    }
  },
  // 这个接口好像没有调用了
  getAppChatRecord: async (app_id: string) => {
    assistantState.isLoadingPage = true
    try {
      const { data } = await getAppChatRecord(
        assistantState.curSelectAssistant.app_id,
      )
    } catch (error) {
    } finally {
      assistantState.isLoadingPage = false
    }
  },
  questionGuide: async (payload: any) => {
    // 获取追问信息
    assistantState.isLoadingQuestion = true
    try {
      const { data } = await questionGuide(payload)
      assistantState.questionGuides = data || []
    } catch (error) {
      console.log('questionGuide error =>', error)
    } finally {
      console.log('questionGuide finally =>', assistantState.isLoadingQuestion)
      assistantState.isLoadingQuestion = false
    }
  },
  getSessions: async (appId: string) => {
    //  获取智能体历史消息
    assistantAction.resetSession()
    assistantState.isLoadingChatRecord = true
    try {
      const { data } = await getSessionsHistory({ appId })
      const groupList = data?.list || []
      assistantState.curChatId = data?.chat_id || nanoid()
      if (groupList.length !== 0) {
        const flatSessions = groupList.flatMap((list: any[], index: number) => {
          return index === groupList.length - 1
            ? [...list]
            : [...list, { newChat: true }]
        })
        assistantState.historyRecord = flatSessions
      }
    } catch (error) {
      console.log('getSessions error =>', error)
    } finally {
      assistantState.isLoadingChatRecord = false
    }
  },
  resetSession: () => {
    // 重置智能体对话
    assistantState.sessionMessages = []
    assistantState.curChatId = ''
    assistantState.sessionStatu = SessionStatuTypes.ready
    assistantState.inputText = ''
    assistantState.historyRecord = []
  },
  updateSessionStatu: (statu: SessionStatuTypes) => {
    //  更新对话状态
    assistantState.sessionStatu = statu
  },
  updateSessionMessages: (messages: any) => {
    // 更新对话列表
    assistantState.sessionMessages = messages
  },
  updateSessionMsgParts: (messages: any) => {
    assistantState.sessionMsgParts = messages
  },
  updateSubmittable: (submittable: any) => {
    assistantState.submittable = submittable
  },
  updateCurSelectAssistant: (data: any) => {
    assistantState.curSelectAssistant = {
      ...assistantState.curSelectAssistant,
      ...data,
    }
  },
  resetCurSelectAssistant: (data: any) => {
    assistantState.curSelectAssistant = {
      ...data,
      image: assistantState.defaultImg, // 头像
      welcome_text: '快来发起问答体验吧～', // 开场白
      temperature: 0.8,
      knowledge_id: '',
      tools: [],
      question_guide: false,
      // debug: false,
    }
  },
  setInputText: (value: any) => {
    assistantState.inputText = value
  },
  updateCurChatId: () => {
    assistantState.curChatId = nanoid(12)
    // assistantState.sessionMessages = []
  },
  cleanCurSelectAssistant: () => {
    // 清除智能体默认信息
    console.log('---------初始化表单-----------')
    assistantState.curSelectAssistant = {
      name: '', // 助手名称
      description: '', // 描述
      image: assistantState.defaultImg, // 头像
      welcome_text: '', // 开场白
      question_recommend: ['这里是预置问题'], // 预置问题
      temperature: 0.8,
      knowledge_id: '',
      tools: [],
      question_guide: false,
      prompt: [],
      debug: true,
    }
    assistantAction.updateSessionMessages([])
    assistantAction.updateSubmittable(false)
    assistantAction.updateCurChatId()
    assistantAction.updateQuestionGuides([])
    assistantState.historyRecord = []
  },
  // 切换助手体验
  changeAgent: () => {
    assistantAction.updateSessionMessages([])
    assistantAction.updateCurChatId()
    assistantAction.updateQuestionGuides([])
    assistantState.historyRecord = []
    assistantAction.updateCurSelectAssistant({
      name: '', // 助手名称
      description: '', // 描述
      prompt: [],
      question_recommend: ['这里是预置问题'], // 预置问题
      image: assistantState.defaultImg, // 头像
      welcome_text: '', // 开场白
      temperature: 0.8,
      knowledge_id: '',
      tools: [],
      question_guide: false,

      // debug: false,
      app_id: null,
    })
  },
  updateQuestionGuides: (payload: any) => {
    //  更新快速回答推荐
    assistantState.questionGuides = payload
  },
  updateHistoryRecord: (payload: any) => {
    assistantState.historyRecord = payload
  },
  updateDefaultKnConfig: (payload: any) => {
    assistantState.defaultKnConfig = {
      ...assistantState.defaultKnConfig,
      ...payload,
    }
  },
  handleNewChat: () => {
    assistantAction.updateQuestionGuides([])
    const messages = assistantState.sessionMessages
    const lastMessage: any = messages[messages.length - 1] || {}
    assistantState.curChatId = nanoid()
    if (!lastMessage.newChat) {
      messages.push({ newChat: true })
    }
  },
}
